module.exports = __WEBPACK_EXTERNAL_MODULE__8748__;